import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerService } from '@core/services/logger.service';

const SLOW_REQUEST_THRESHOLD_MS = 3000;

@Injectable()
export class HttpTimingInterceptor implements HttpInterceptor {
  constructor(private readonly logger: LoggerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('/assets')) {
      return next.handle(request);
    }

    const start = Date.now();
    let status = 0;

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          status = event.status;
        }
      }),
      catchError((err: HttpErrorResponse) => {
        status = err.status ?? 0;
        throw err;
      }),
      finalize(() => {
        const durationMs = Date.now() - start;
        const properties = {
          url: request.url,
          method: request.method,
          status: String(status),
          durationMs: String(durationMs),
          correlationId: request.headers.get('X-Correlation-ID') ?? ''
        };
        if (durationMs >= SLOW_REQUEST_THRESHOLD_MS) {
          this.logger.warn(`Slow HTTP request: ${request.method} ${request.url} (${durationMs}ms)`, properties);
        } else {
          this.logger.info('HttpRequest', properties);
        }
      })
    );
  }
}
